import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from '../Modal';
import { useAuth } from '../../hooks/useAuth';
import Button from '../Button';

interface Props {
  onClose: () => void;
}
export const PinModal: React.FC<Props> = ({ onClose }) => {
  const { pin } = useAuth();

  return (
    <Modal
      open={true}
      onClose={onClose}
      className="!p-0 !bg-transparent backdrop-blur-none"
    >
      <div className="bg-white p-8 w-[300px] rounded-lg flex flex-col items-center gap-7">
        <p className="text-gray-medium text-lg">
          <FormattedMessage defaultMessage="Din pinkod är" />
        </p>
        <p className="text-4xl font-bold">{pin}</p>
        <Button onClick={onClose}>
          <FormattedMessage defaultMessage="Stäng" />
        </Button>
      </div>
    </Modal>
  );
};
